import type { Event } from '@patsnap/tahiti-core';

/**
 * Loader 加载进度事件数据
 */
export interface LoaderProgressEvent {
    /**
     * Loader 名称
     */
    loaderName: string;

    /**
     * 加载状态：'start' | 'complete' | 'error'
     */
    status: 'start' | 'complete' | 'error';

    /**
     * 错误信息（仅在 status 为 'error' 时存在）
     */
    error?: Error;
}

/**
 * OAR 任务数据编排服务接口
 *
 * 负责协调所有 OarTaskDataLoader 的执行，自动收集数据并更新到 OarTaskContentModel
 */
export interface OarTaskDataOrchestrator {
    /**
     * 加载所有可用的数据
     *
     * 执行流程：
     * 1. 先执行 TaskInfo Loader（获取各部分的解析状态）
     * 2. 根据解析状态，并行执行其他 Loader
     *
     * @param taskId - 任务 ID
     */
    loadAll(taskId: string): Promise<void>;

    /**
     * 加载特定部分的数据
     *
     * @param taskId - 任务 ID
     * @param loaderName - Loader 名称（'TaskInfo', 'Header', 'Table', 'Body'）
     */
    loadPart(taskId: string, loaderName: string): Promise<void>;

    /**
     * Loader 加载进度事件
     *
     * 当任何 Loader 开始/完成/失败时触发
     */
    readonly onLoaderProgress: Event<LoaderProgressEvent>;
}

/**
 * OarTaskDataOrchestrator 的 DI Symbol
 */
export const OarTaskDataOrchestrator = Symbol('OarTaskDataOrchestrator');
